/**
 * YearSelect Component
 * Simple text input for entering a year for TSI analysis
 */

import { useState } from 'react';

function YearSelect({ selectedYear, onSelect, disabled }) {
  const [inputYear, setInputYear] = useState(selectedYear || '');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate year
    const year = parseInt(inputYear);
    const currentYear = new Date().getFullYear();
    
    if (!inputYear || isNaN(year)) {
      setError('Please enter a valid year');
      return;
    }
    
    if (year < 1900 || year > currentYear) {
      setError(`Year must be between 1900 and ${currentYear}`);
      return;
    }
    
    setError('');
    onSelect(year);
  };

  return (
    <div className="year-select">
      <h2>Select Year</h2>
      <p className="step-description">
        Enter the year to analyze for the Tom Short Index
      </p>

      <form onSubmit={handleSubmit} className="year-input-form">
        <input
          type="number"
          min="1900"
          max={new Date().getFullYear()}
          value={inputYear}
          onChange={(e) => {
            setInputYear(e.target.value);
            setError('');
          }}
          placeholder="e.g. 2024"
          className="year-input"
          disabled={disabled}
        />
        <button 
          type="submit" 
          className="year-submit-button"
          disabled={disabled || !inputYear}
        >
          Calculate TSI
        </button>
      </form>

      {error && <p className="year-error">{error}</p>}
      
      {selectedYear && !error && (
        <p className="year-selected">
          Analyzing year: <strong>{selectedYear}</strong>
        </p>
      )}
    </div>
  );
}

export default YearSelect;
